import {createReducer, on} from '@ngrx/store';
import {
  clearStartManyProductionInstancesState,
  startManyProductionInstances,
  startManyProductionInstancesFailure,
  startManyProductionInstancesSuccess
} from './production-instance.start-many.actions';


export interface State {
  record: null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const startManyProductionInstancesReducer = createReducer(
  initialState,

  on(startManyProductionInstances, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(startManyProductionInstancesSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(startManyProductionInstancesFailure, (_state: State, action: {error: any}): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearStartManyProductionInstancesState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

